import React, { useEffect } from "react";

const CookieYes = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.id = "cookieyes"
        script.type = "text/javascript"
        script.src = "https://cdn-cookieyes.com/client_data/53f25bb618fb825685ac433818c60afd/script.js"

        document.head.appendChild(script);

    }, [])

    return (
        <></>
    )
}

export default CookieYes
